import { createFileRoute } from '@tanstack/react-router'
import { usePageTitle } from '../../../features/page-title/pageTitle.ts'
import { LiveblogProfilesPage } from '../../../features/liveblog-profiles/LiveblogProfilesPage.tsx'
import { me } from '../../../i18n.ts'

export const Route = createFileRoute('/me/_settings/liveblog-profiles')({
  component: RouteComponent,
})

function RouteComponent() {
  const t = me.useT()
  usePageTitle(t('pageTitle.authorProfiles'))
  return <LiveblogProfilesPage />
}
